export default __webpack_public_path__ + "static/media/templates.5e3cd879.svg";